import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import Papa from 'papaparse';

const SCHEMAS = {
    ETABLISSEMENTS: ["Nom", "Adresse", "Code postal", "Ville"],
    PRODUITS: ["ref", "libelle", "prix_ht", "stock"],
    COMMANDES: ["commande_id", "date", "client_email", "total"]
};

const CSVImporter = () => {
  const [selectedType, setSelectedType] = useState("ETABLISSEMENTS");
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [error, setError] = useState(null);

  const onDrop = useCallback((acceptedFiles) => {
    setError(null);
    const file = acceptedFiles[0];

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const fileHeaders = Object.keys(results.data[0] || {});
        const expectedHeaders = SCHEMAS[selectedType];

        // Vérification de la structure
        const isValid = expectedHeaders.every(h => fileHeaders.includes(h));

        if (!isValid) {
          setError(`Format invalide pour ${selectedType}. Colonnes attendues : ${expectedHeaders.join(", ")}`);
          setData([]);
        } else {
          setHeaders(fileHeaders);
          setData(results.data);
        }
      }
    });
  }, [selectedType]);

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: { 'text/csv': ['.csv'] } });

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
      <h3>1. Choisissez le type d'import</h3>
      <select 
        value={selectedType} 
        onChange={(e) => { setSelectedType(e.target.value); setData([]); setError(null); }}
        style={{ marginBottom: '20px', padding: '8px' }}
      >
        <option value="ETABLISSEMENTS">Etablissements</option>
        <option value="PRODUITS">Produits</option>
        <option value="COMMANDES">Commandes</option>
      </select>

      <h3>2. Importez le fichier</h3>
      <div {...getRootProps()} style={dropzoneStyle}>
        <input {...getInputProps()} />
        <p>Glissez le CSV des <strong>{selectedType.toLowerCase()}</strong> ici</p>
      </div>

      {error && <p style={{ color: 'red', fontWeight: 'bold' }}>⚠️ {error}</p>}

      {data.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          <h3>Aperçu ({data.length} lignes détectées)</h3>
          <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f4f4f4' }}>
                {headers.map(h => <th key={h}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {data.slice(0, 5).map((row, i) => (
                <tr key={i}>
                  {headers.map(h => <td key={h} style={{ padding: '5px' }}>{row[h]}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={() => alert("Envoi de " + JSON.stringify(data[0]))} style={btnStyle}>
            Valider l'import des {selectedType}
          </button>
        </div>
      )}
    </div>
  );
};

const dropzoneStyle = { border: '2px dashed #007bff', padding: '20px', textAlign: 'center', cursor: 'pointer', backgroundColor: '#f9f9f9' };
const btnStyle = { marginTop: '20px', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' };

export default CSVImporter;